import { render, staticRenderFns } from "./V6SlideTestimony.vue?vue&type=template&id=4690c7d7&scoped=true&"
import script from "./V6SlideTestimony.vue?vue&type=script&lang=js&"
export * from "./V6SlideTestimony.vue?vue&type=script&lang=js&"
import style0 from "./V6SlideTestimony.vue?vue&type=style&index=0&id=4690c7d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4690c7d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
